export { default as Pill } from "./Pill";
